import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class TdspInsertionOrderService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_TDSP_URL}/insertion-order/`;

  getIOChangeLogs(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/change-log`, "", params);
    return this.get(url);
  }

  pixelBulkEdit(data, params) {
    let url = this.buildUrl(
      `${this.resource_url}bulk-edit-pixels/`,
      "",
      params
    );
    return this.patch(url, data);
  }

  flightBulkEdit(data, params) {
    let url = this.buildUrl(
      `${this.resource_url}bulk-edit-flights/`,
      "",
      params
    );
    return this.patch(url, data);
  }
}
